import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

type Props = {
  isOpen: boolean;
  onContinue: () => void;
  onGoBack: () => void;
  canReactToCollabComments?: boolean;
};

export const DismissConfirmationModal = ({
  isOpen,
  onContinue,
  onGoBack,
  canReactToCollabComments,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onGoBack}
      isCentered
      size="sm"
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent maxW="368px">
        <ModalHeader textAlign="center" pb="6px">
          {translate('Add your name')}
        </ModalHeader>
        <ModalBody
          textAlign="center"
          fontSize="14px"
          fontWeight="normal"
          color="text-secondary"
          pt={0}
          pb="24px"
        >
          {canReactToCollabComments
            ? translate('Enter your name to comment or react and let others know who you are.')
            : translate('Enter your name to comment and let others know who you are.')}
        </ModalBody>
        <ModalFooter pt={0}>
          <Stack spacing={2} width="100%">
            <Button variant="primary" width="100%" onClick={onContinue}>
              {translate('Enter name')}
            </Button>
            <Button variant="tertiary" width="100%" onClick={onGoBack}>
              {translate('Go back to draft')}
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
